var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "30.998px",
    height: "39.276px",
    viewBox: "15.986 7.9 30.998 39.276",
    enableBackground: "new 15.986 7.9 30.998 39.276",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    transform: "translate(-0.474 -0.467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    fill: "#4BC1D4",
    d: "M41.692,14.132c7.673,7.651,7.689,20.073,0.038,27.745c-6.704,6.724-17.261,7.68-25.065,2.271 l-0.205-0.144l2.068-2.908c7.241,5.119,17.26,3.397,22.379-3.844c5.117-7.24,3.396-17.26-3.845-22.378 c-5.414-3.827-12.624-3.932-18.147-0.266l-0.191,0.129l-2.023-2.945C24.51,6.458,35.011,7.441,41.692,14.132z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStatus);
export default __webpack_public_path__ + "static/media/icon-status.0fc4c98e092e2d8b5f8d562ede83ed9c.svg";
export { ForwardRef as ReactComponent };